import { apiPrefix } from '../constants'

export default {
  getUsers: {
    type: 'get',
    url: `${apiPrefix}admin/users`,
  },
  addUser: {
    type: 'post',
    url: `${apiPrefix}admin/user`,
  },
  updateUser: {
    type: 'put',
    url: `${apiPrefix}admin/user`,
  },
  deleteUser: {
    type: 'delete',
    url: `${apiPrefix}admin/user`,
  },
  hasRoot: {
    type: 'get',
    url: `${apiPrefix}admin/hasRoot`,
  },
  createRoot: {
    type: 'post',
    url: `${apiPrefix}admin/createRoot`,
  },
}
